import { Typography } from "@mui/material";
import React from "react";
import styles from "./Terms.module.css";

function Terms() {
  return (
    <div className={styles.terms}>
      <h3>Terms and Conditions for Stanbic IBTC Bank Home Loan </h3>
      <br />
      <h5>1.Introduction and Acceptance</h5> 
      <br />
      <Typography>
        1.1.	This Stanbic IBTC Bank PLC (“We “, “Us”, “Our” or “the Bank”) Home Loans Portal (“Site”) is a website designed for mortgage origination by our customer(s) (“User” or “Users” “You”) as part of the Bank’s digitized mortgage application process. 
      </Typography>
      <Typography>
        1.2.	This Site may be utilized for initiating a mortgage application, using the mortgage calculator (“our Services”) and third-party property listings. If the User’s mortgage application is successful, the Bank may issue an offer letter to the User subject to the fulfilment of the conditions precedent (contained in the Bank’s offer letter) if found to be satisfactory by the Bank.
      </Typography>
      <Typography>
        1.3.	The inclusion of hyperlinks to other third-party property listing websites on this Site is strictly for the User’s convenience for purposes of sourcing property, for the mortgage contemplated herein. You acknowledge and agree that when you access and use such property listing websites, you do so at your own risk. Please note the disclaimers at clause 10 below. 
      </Typography>
      <Typography>
        1.4.	The Services are available to User(s) resident in Nigeria on terms and conditions (Terms) set out herein. By continuing to access, view or make use of this Site [and any related content and services]. If you are not located in Nigeria, you may use the Site [and any related content and services] but the services are exclusively for the residential finance of properties domiciled in Nigeria with loans & repayments in Nigerian naira currency only. 
      </Typography>
      <Typography>
        1.5.	By accessing this Site, you acknowledge and accept these Terms as legally binding between you and the Bank for purposes of the online application of the Bank’s home loan. If you do not agree to these Terms, then you may not access the Site, or the Services provided by the Bank.
      </Typography>
      <Typography>
        1.6.	By clicking “I accept”, you agree to be bound by these Terms, all policies, applicable laws, regulatory guidelines, rules, terms contained in the Bank’s offer letter(s), provisions communicated by the Bank from time to time; all of which are hereby incorporated by reference into this Terms. 
      </Typography>
      <Typography>
      1.7.	You acknowledge and accept that the home loan applied for through this Site, if approved and disbursed, shall be used exclusively for the purpose of funding the purchase of a property.
      </Typography>
      <hr />
      <br />
      <h5>2.	Description of the Services</h5>
      <br />
      <Typography>
        2.1.	The Bank offers the following Services through this Site:
      </Typography>
      <Typography>
        2.1.1.	Mortgage application: Users can apply and submit a mortgage application with the required documents for the Bank’s assessment of their eligibility for a mortgage. 
      </Typography>
      <Typography>
        2.1.2.	Mortgage calculator: Users can calculate an estimated monthly mortgage repayment derived from applying the property price, down payment or equity contribution and other loan indices using an automated tool on the Site. 
      </Typography>
      <Typography>
        2.2.	The terms and conditions in the Bank’s offer letter will determine the actual monthly mortgage repayment. Where there is a conflict between the estimated monthly mortgage repayment derived from the mortgage calculator and the actual monthly mortgage repayment, the terms of the Bank’s offer letter will supersede. 
      </Typography>

      <hr />
      <br />
      <h5>3.Submission of required documents</h5>
      <br />
      <Typography>
        3.1.	The User shall be required by the Bank to provide requisite documentation while completing an application on this Site and it shall be mandatory for the User to submit all such documents.
      </Typography>
      <Typography>
        3.2.	The Bank shall not consider a mortgage application without the submission of the requisite documentation and consequently, shall not be liable to the User for not considering such incompetent application. 
      </Typography>
      <hr />
      <br />
      <h5>4.Personal information</h5>
      <br />
      <Typography>
        4.1.	The User consents to the Bank using and processing its personal information and submission of personal information through the Site which is governed by our Privacy Policy   The Bank shall be responsible for the control of personal information and assures the User that the personal information will be processed only for the purpose of administering the requested service.
      </Typography>
      <Typography>
      4.2.	You hereby authorize the Bank to collect, use, transfer, store or in other ways process your personal data and declare that the information you shall provide is true and accurate, and you agree to be bound by the provisions referenced in these terms.
      </Typography>

      <hr />
      <br />
      <h5>5.Accuracy of information supplied.</h5>
      <br />
      <Typography>
        5.1.	The User shall provide such documentation/ information as the Bank may from time to time reasonably require for the purposes of processing the online application for home loan or other related services through the site. 
      </Typography>
      <Typography>
      5.2.	The User is responsible for the accuracy and authenticity of information supplied to the Bank through the use of this Site. 
      </Typography>
      <Typography>
        5.3.	The Bank accepts no liability for processing or for consequences arising out of processing erroneous or incomplete or incorrect information provided by the User. 
      </Typography>
      <Typography>
        5.4.	Where the User notices an error in the information it supplied/provided to the Bank through the Site, the User shall advise the Bank immediately within Forty-eight (48) hours. The Bank will endeavour to correct such errors wherever possible on a best-efforts basis. 
      </Typography>

      <hr />
      <br />
      <h5>6. Your Authority</h5>
      <br />
      <Typography>
        6.1.	You permit the Bank to regard all activities you conduct on the Site, or instructions sent by you when you commence the online application for the home loan as being authorized by you and intended to have legal force and effect.
      </Typography>
      <Typography>
        6.2.	You authorise the Bank to send documentation/advice to your registered electronic mail (“email”) provided by you on the Site as requirements under Section 3 of these Terms. You are aware that email is not a secure or error-free medium of communication and you are aware of the possible risks involved in connection with the transmission of information via email. 
        </Typography>
        
        <hr />
        <br />

        <h5>7. Access to the Site</h5>
        <br />
      <Typography>
        7.1.	To use our Services, you must register by signing up to create a User Account. 
      </Typography>
      <Typography>
      7.2.	To set up your User Account, you are required to provide only a valid email address and password. 
        </Typography>
        <Typography>
        7.3.	Following the successful creation of your User Account, you shall be required to update your profile with other personal details (including address, gender, Bank Verification Number and/or Personal Identification Number amongst other information). 
        </Typography>
        <Typography>
        7.4.	All data collected by the Bank will be stored and used by the Bank in accordance with our Privacy Policy. Check [Privacy Policy link] to see a detailed explanation of how we will use your personal data.
        </Typography>
        <Typography>
        7.5.	If a User selects a password as part of our security procedures through the site, such User shall treat the password as confidential and must not disclose it to any third party. 
        </Typography>
        <Typography>
        7.6.	The Bank reserves the right to disable any user identification password chosen by a User at any time, if in our reasonable opinion such User has failed to comply with any of the provisions of these Terms.
        </Typography>
        <Typography>
        7.7.	The User shall not facilitate any viruses, Trojan horses, worms, or other computer programming routines that may damage, detrimentally interfere with, surreptitiously intercept, or expropriate any system, data, or information.
        </Typography>
        <hr />
        <br />
        <h5>8.Due Diligence</h5>
        <br />
        <Typography>
          8.1.	The Bank shall perform the necessary Know your customer (KYC) & due diligence on the User, upon request by Bank, the User shall provide all documentation or information required by the Bank.
        </Typography>
        <Typography>
          8.2.	The User agrees that as a pre-condition for the processing of the mortgage application by the Bank, and we  are authorized to carry out due diligence with the information provided from the Credit Risk Management System (CRMS) and at least two Credit Bureaux or such other checks as may be required by any regulatory agency from time to time and you hereby authorize us to debit your account for the cost of such checks.
        </Typography>
        <hr />
        <br />
        <h5>9.Website Maintenance</h5>
        <br />
        <Typography>
        9.1.	The Site may from time to time require maintenance and during such periods it may not be accessible to a User or possible to process the requests of Users. This may result in delays and/or failure in processing instructions. 
        </Typography>
        <Typography>
        9.2.	The User understands that the Bank disclaims any and all liability, whether direct or indirect, or otherwise arising out of any failure or inability by the Bank to honour any user instruction during the maintenance of this Site or for any reasons.
        </Typography>
        <Typography>
        9.3.	We may suspend or withdraw this Site.
        </Typography>
        <hr />
        <br />
        <h5>10.	       Disclaimer for Third Party Property listings & Third-Party Links</h5>
        <br />
        <Typography>
          10.1.	Users can through the Site access Third Party websites that advertise Property listings on the web, these Properties are offered by Third Parties on Third party websites and are not managed or secured by Stanbic IBTC. 
        </Typography>
        <Typography>
          10.2.	This Site may contain hyperlinks to third-party property listing websites not controlled by the Bank. We do not editorially control, examine or evaluate the veracity or accuracy of the content, products, services and/or any other transaction made in connection with such third-party websites and the Bank shall not be liable, in any manner whatsoever, for access to, or the inability of access to, or the use, or inability to use the content available on or through such website. 
        </Typography>
        <Typography>
          10.3.	The User undertakes and accepts the sole responsibility for conducting the requisite due diligence on properties listed on the third-party websites to ensure that they are free of all encumbrances before requesting the Bank to finance the acquisition of such property.  
        </Typography>
        <Typography>
        10.4.	The User undertakes to carefully review the third-party’s property listing policies and terms to ensure proper understanding before engaging in any transaction or involving the Bank to finance a property. 
        </Typography>
        <Typography>
        10.5.	Complaints, claims, concerns, or questions regarding third-party properties or products should be directed solely to the third-party and not to the Bank.
        </Typography>
        <Typography>
        10.6.	Any link to third-party property listing websites and advertisements made on such website should not be taken as an endorsement by the Bank of any kind. The Bank shall not be responsible nor liable for any misleading or inaccurate advertisements which are or remains the sole responsibility of the third-party website owner or licensee.
        </Typography>
        <Typography>
        10.7.	The Bank does not act as, nor hold itself out to be an agent, representative, proxy, or broker of any third party. Consequently, we do not expressly nor impliedly represent to hold title in the properties listed on any third-party property listing websites nor warrant that any such property(ies) is free from any encumbrance.  
        </Typography>
        <Typography>
        10.8.	Where the User accesses or uses any third-party’s website from a link contained in this Site or the Services, the User acknowledges and agrees that We are not responsible nor liable for any disputes, claims, losses, injuries, or damage of any kind related to or arising from your access, use, or inability to access or use such third-party’s website or content. 
        </Typography>
        <Typography>
          10.9.	The Bank does not warrant nor provide any guarantee or assurances that the third-party content accessed from links contained in this Site or elsewhere will be free of material you may find objectionable or otherwise inappropriate or of malware or other contaminants that may harm your computer, mobile device, or any files therein
        </Typography>
        <Typography>
        10.10.	Additionally, the Bank shall not accept responsibility nor liability for any information shared, payments processed or submitted through the third-party website, or for the privacy policies of any such sites. 
        </Typography>
        <Typography>
        10.11.	The Bank shall not endorse any services offered by third parties and we urge our Users to exercise caution in using third-party websites
        </Typography>
        <hr />
        <br />
        <h5>11.	Offer Letter</h5>
        <br />
        <Typography>
        11.1.	Upon completion of the Mortgage Application process accessed through this Site, subject to an approval by the Bank after the requite, satisfactory due diligence, the Bank may issue to the User an Offer letter via the email provided by the User or in person at any designated branch approved by the Bank.
        </Typography>
        <Typography>
        11.2.	Where the Bank’s offer letter is issued to a User and sent to their registered email, subsequently a relationship manager of the Bank will contact to the User to confirm that the User is in receipt of the Offer letter.  
          </Typography>
          <Typography>
          11.3.	Offer Letters may be signed/executed by Electronic Signature, in consideration of the User to signing/executing its Offer Letter by Electronic Signature, the User represents that its Electronic Signature will be genuine, that each Electronic Signature will represent the signature of the person required to sign the Offer letter or other form to which such Electronic Signature is affixed; The User represents that the Bank may accept any Electronic Signature without any responsibility to verify or authenticate that it is the signature and the Bank may act in accordance with the instructions authorized by Electronic Signature without any responsibility to verify that the User intended to give the Electronic Signature for the purpose of authorizing the User’s Mortgage Application.
          </Typography>

          <hr />
        <br />
        <h5>12.	User’s Bank Account  </h5>
        <br />
        <Typography>
        12.1.	A User must have a Bank account, or any other account specified with the Bank as part of its Mortgage application, there will be need for the User to provide consent to open a Bank account.  The Bank shall not approve a mortgage application without the User’s Bank account details.
        </Typography>
        <hr />
        <br />
        <h5>13. Indemnity</h5>
        <br />
        <Typography>
        13.1.	The User hereby agree to fully and effectively indemnify, defend and hold the Bank  and its affiliates, their respective officers, directors, owners, agents, service providers,  licensors, subcontractors, suppliers, interns and employees, harmless from and against any and all claims, liability, losses, costs and expenses (including lawyers' fees) incurred by the Bank  in connection with any use or alleged use of the Service under the User’s  password by any person, whether or not authorized by the User.
        </Typography>
        <Typography>
        13.2.	User shall indemnify and hold the Bank harmless from and against all actions, proceedings, costs, claims, demands, charges, expenses (including legal expenses), liabilities, fines, levies, losses, and damages, whether arising in tort, contract, or common law, which the Bank may suffer or incur to the extent arising out of or in consequence of or in connection with:
        </Typography>
        <Typography>
        •	any claim brought against the Bank arising from any aspect of this Terms (including but not limited to, and in connection with any security breach, compromise or theft of Data held by the User or on behalf of the User irrespective of whether such security breach, compromise or theft of Data was within or outside User’s control). 
        </Typography>
        <Typography>
        •	the enforcement or attempted enforcement of this Terms (which includes the recovery or attempted recovery of any sum owing to the Bank under this Terms or pursuant to the disbursed home loan. 
        </Typography>
        <Typography>
        •	the protection of the Bank’s interest in connection with any aspect of these Terms (including the cost of any third parties nominated by the Bank or instructed by the Bank for this purpose). 
        </Typography>
        <Typography>
        •	a breach by the User of any of the provisions of this Terms
        </Typography>
        <Typography>
        13.3.	User agrees that if a fraudulent activity is associated with the operation of its accounts, the Bank shall have the right to apply restrictions to such account and report to appropriate law enforcement agencies.   
        </Typography>
        <hr />
        <br />
        <h5>14.Disclaimer</h5>
        <br />
        <Typography>
        14.1.	The Bank maintains this site to provide information pertaining to the Bank’s Home Loan services to the Users. Such information may be subject to amendment and updating without notice
        </Typography>
        <Typography>
        14.2.	The information contained on this Site is for general information purposes as it relates to the provision of the Service specified under these Terms. Whilst we endeavour to keep the information correct and up to date, we make no representations and warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the Site or the information, products, Services or related graphics contained on the site for any purpose. 
        </Typography>
        <Typography>
        14.3.	User agrees that reliance on information contained herein is strictly at his/her own risk. In no event will the Bank be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits which arise out of or in connection with the use of this site. 
        </Typography>
        <Typography>
        14.4.	The Bank makes no representation or warranty of any kind whatsoever, express, or implied, to the User regarding the validity of title to the property, suitability for purpose, completeness, or accuracy of the title documents, material facts that may affect the User’s decision to purchase a property and We expressly disclaim any liability to the User for third-party disputes or claims involving the property.
        </Typography>
        <Typography>
        14.5.	No license to the User is implied in these disclaimers
        </Typography>
        <hr />
        <br />
        <h5>15.	Exclusion on Liability </h5>
        <br />
        <Typography>
        15.1.	The Bank will not be liable for any errors or omissions in the information provided on the site or for any delay, difficulty in use, inaccuracy of information, computer viruses, other defect in this website or your inability to use this website to your satisfaction. 
        </Typography>
        <Typography>
        15.2.	Under no circumstances will Bank be liable for any lost profits or any form of damages arising out of any use of or inability to use the Site or any portion thereof, regardless of whether the Bank has been informed of the likelihood of such damages occurring and regardless of the form of action, whether in contract, tort, or otherwise.
        </Typography>
        <Typography>
        15.3.	The Bank will not be liable for any losses associated with sending documents/advices and communicating via the User’s registered email, the User understands and acknowledges that there are inherent risks involved in sending the instructions / communications / documents via emails and shall ensure that they keep their emails secure, the User hereby agrees and confirms that all risks shall be fully borne by the User and the User assumes full responsibility for the same.
        </Typography>
        <hr />
        <br />
        <h5>16.Termination </h5>
        <br />
          <Typography>
          16.1.	The Bank may at its absolute discretion terminate these Terms and/ or suspend the provision of the Services under this Terms in whole or part:
          </Typography>
          <Typography>
          •	Immediately with or without notice if a User is in breach of any of these Terms.
          </Typography>
          <Typography>
          •	Immediately upon gaining knowledge or information about the death, or legal incapacity of the User.
            </Typography>
            <Typography>
            •	Immediately upon the User becoming insolvent or any step is taken for User liquidation, winding-up, bankruptcy, receivership, administration or dissolution (or anything analogous to the foregoing occurs in any jurisdiction). 
            </Typography>
            <Typography>
            •	Immediately, if the Bank in its absolute discretion, determines that User’s lacks the capacity to perform the contract under the Terms, if the likelihood of increased risk of loss or liability.
            </Typography>
            <Typography>
            •	At any time, for no reason without prior notice to you.
            </Typography>

          <hr />
          <br />
          <h5>17.Notices </h5>
          <br />
          <Typography>
          17.1.	Under these Terms, notices to Users may be given through any medium of communication as may be deemed appropriate by the Bank i.e., this Site, Bank's website (www.stanbicibtcbank.com) or email, SMS, public notices at Branches, or through newspapers, radio, TV, etc. 
          </Typography>
          <Typography>
          17.2.	You agree that the Bank may issue notices required in respect of these Term and which also forms a part of these Terms. Such notices shall l have the same effect as a notice served individually to each User.
          </Typography>
          <Typography>
          17.3.	The User is to keep its primary email address updated to enable an electronic communication with the Bank. User understands and agree that if the Bank sends an electronic mail, but User does not receive it due to the primary email address on file being incorrect, outdated, blocked, or otherwise unable to receive electronic communications, the Bank will be deemed to have provided the communication to the User effectively.
          </Typography>
          <Typography>
          17.4.	All communications to the Bank must be sent by email to HomeLoans@stanbicibtc.com or in writing delivered at Home Loans Unit, Products, Second Floor Stanbic IBTC Bank PLC, Plot 1712 Idejo Street, Victoria Island, Lagos   
          </Typography>
          <hr />
          <br />
          <h5>18.	Privacy Statement  </h5>
          <br />
          <Typography>
          18.1.	User acknowledges that by use of this Site the Bank shall be privy to and store some of its personal information (full name, mobile phone number and email address) in accordance with our Privacy Policy. Check [Privacy Policy link]. The Bank may use User’s personal information for: 
          </Typography>
          <Typography>
          18.1.1.	providing the service, processing transactions and sending the User related   information. 
          </Typography>
          <Typography>
          18.1.2.	providing, maintaining and improving the services. 
          </Typography>
          <Typography>
          18.1.3.	sending support and administrative messages to User. 
          </Typography>
          <Typography>
          18.1.4.	responding to User enquiries and requests. 
          </Typography>
          <Typography>
           18.1.5.	providing customer service. 
          </Typography>
          <Typography>
          18.1.6.	updating User on products, services, promotions, rewards, and events offered by the Bank and related third parties; and 
          </Typography>
          <Typography>
          18.1.7.	a better understanding of User needs by combining it with information collected from others with the objective of improving on service delivery. 
          </Typography>
          <Typography>
          18.2.	The Bank may disclose any information it collects about User to third parties including regulatory bodies; financial institutions; companies that perform marketing services on the Bank’s behalf; to enable the Bank to provide the Site; and if required to be disclosed under applicable law or by a governmental order, decree, regulation or rule or by a court order. 
          </Typography>
          <Typography>
          18.3.	User consents to the processing and transfer of its information during and after the use of the site.  
          </Typography>
          <hr />
          <br />
          <h5>19.	Force Majeure  </h5>
          <br />
          <Typography>

            19.1.	The Bank shall not be liable for any delay in performing or failure to perform any  obligations under these Terms, where such non-performance or failure to perform is caused by circumstances beyond its reasonable control, including, but not limited to, the failure, malfunction or unavailability of telecommunications, data communications and/or computer systems and services, natural calamities, war, civil unrest, government action, strikes, lock-outs and/or other industrial action or trade disputes (whether involving the Bank's employees or those of a third party). Any delay or failure of this kind will not be deemed to be a breach of the Terms and the time for performance of the affected obligation will be extended by a period which is reasonable in the circumstances.
          </Typography>
          <hr />
          <br />
          <h5>20. Intellectual Property Rights </h5>
          <br />
          <Typography>
          20.1.	The Bank grants the right to access this site to the User for the purposes of utilizing the Services in accordance with the Terms mentioned herein. The copyright, trademarks, logos, slogans, and service marks displayed on the site are registered and unregistered intellectual property rights of the Bank or of the respective intellectual property right owners. The contents of the Site include all audio, video, graphics, images and textual materials, downloadable files, pdfs, Microsoft word, etc. All contents are protected by international copyright law. Nothing contained on the site should be construed as granting, by implication, estoppels, or otherwise, any license or right to use any intellectual property displayed on the site without the written permission of the Bank or such third party that may own the intellectual property displayed on the site.
          </Typography>
          <hr />
          <br />
          <h5>21. Dispute Resolution/Governing Laws  </h5>
          <br />
          <Typography>
          21.1.	All disputes arising out of or in connection to the use of this Site, the interpretation of these Terms or any matter arising from these Terms shall be subject to the jurisdiction of courts in Nigeria. 
          </Typography>
          <Typography>
          21.2.	The relationship between the User and the Bank shall be governed and construed in accordance with Nigerian laws and by reference to the accepted principles and practices of banking.
          </Typography>
          <hr />
          <br />
          <h5>22. Waiver</h5>
          <Typography>
          22.1.	No failure or delay by the Bank to exercise any rights is to be construed as a waiver of any such right, whether this is done expressly or is implied. It will also not affect the validity of any part of these Terms or prejudice Our right to take subsequent action against you.
          </Typography>
          <hr />
          <br />
          <h5>23.	Modification </h5>
          <br />
          <Typography>
            23.1.	The Bank reserves the right to change or modify all or any part of these Terms at any time, effective immediately upon notice published on the website. It is your sole responsibility to periodically check this page for changes and you are bound by the version of the Terms that exist at the time you access the Site. 
          </Typography>
          <Typography>
          23.2.	If at any time these Terms are no longer acceptable to you, you may immediately cease all use of the Service
          </Typography>
          <hr />
          <br />
          <h5>24. Contact Us </h5>
          <br />
          <Typography>
          24.1.	You may contact us to discuss our Services at any of Our branches or by contacting us at homeloans@stanbicibtc.com / +234 01 422 2222. These Terms shall be available at the Stanbic IBTC Bank’s website and the home loan portal.  
          </Typography>
    </div>
  );
}

export default Terms;
